<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Fzgwv8/tc-custom/9781455607778.jpg?1736424465200" alt="This image is the cover for the book Louisiana in Words"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Louisiana in Words
      </h1>
      <p class="bookDescription body article font2">
        <p>"Louisiana in Words is a Book of Hours for a place that's more like a religion than a state." -Josh Russell, author of Yellow Jack</p><p>"Here we are, Louisianians all, somewhere in this book, but after that sense of self-recognition comes a desire to go to every place in this book, see it, know it like the writer does, experience our home state's every corner." -New Orleans Times-Picayune</p><p>Taste, smell, hear, and see Louisiana in this collection of one-minute experiences taking place over a twenty-four-hour period across the Pelican State. One hundred twenty Louisiana-born or current resident contributors of all ages, backgrounds, and perspectives have offered their grateful, graceful, and grave visions of the state, a place as evocative as the essays within this gathering of voices.</p><p>The ultimate insider's look, the book provides an unparalleled feel for hitherto hidden worlds inside the state. Together these minutes provide a mosaic of the landscape, heritage, speech, and traditions of Louisiana, a place so often romanticized, demonized, adored, pitied, and patronized.</p><p>Contributors were asked to write one page or less about one minute, anytime, anywhere, in Louisiana. Writers selected include award-winning writers such as John Biguenet, Andrei Codrescu, Barry Gifford, Bev Marshall, David Madden, Lee Meitzen Grue, and Fredrick Barton as well as novice writers of all ages. Passages cast Louisiana's diverse peoples as backdrop against the action that transpires within the minute. Authors and their stories' settings reflect the entire state, from the northeast corner near Lake Providence to Lake Charles in the southeast; from Monroe along the Ouachita River and Shreveport in the northwest to Lafayette, the heart of Cajun country; from the south-centrally located Alexandria on the Red River to the southernmost port of New Orleans. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joshua Clark
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pelican Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1ef60fab